function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_569",
  "data-name": "Rectangle 569",
  width: 375,
  height: 302,
  transform: "translate(0 510)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.965,
  y1: 0.247,
  x2: 0.245,
  y2: 0.884,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff3d5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffefc9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 1.314,
  y1: 0.439,
  x2: 0,
  y2: 0.577,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#acb2fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#798df3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 0.351,
  y1: 0.619,
  x2: 0.722,
  y2: 0.572,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#848dff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d2c9ef"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f6f6f6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c9e1ff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2214",
  "data-name": "Group 2214",
  transform: "matrix(0.469, 0.883, -0.883, 0.469, 278.97, 603.154)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9153",
  "data-name": "Path 9153",
  d: "M7.337,231.709A180.835,180.835,0,0,1,130.066,7.336c95.847-28.067,196.342,26.87,224.41,122.718a180.853,180.853,0,0,1-301.15,179A180.413,180.413,0,0,1,7.337,231.709Z",
  transform: "translate(0.003 0)",
  fill: "#8077f6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9154",
  "data-name": "Path 9154",
  d: "M0,177.61a131.887,131.887,0,0,0,14.646-9.658c50.422-39.015,38.2-104.6,71.737-151.19,20.5-28.476,50.822-15.5,74.846.932,25.954,17.806,48.848,27.136,77.208,40.188,26.01,11.922,46.413,28.135,61.274,47A180.584,180.584,0,0,1,178.381,223a179.9,179.9,0,0,1-100.82.234A174.706,174.706,0,0,1,59.029,216.8,182.181,182.181,0,0,1,0,177.61Z",
  transform: "translate(53.328 131.439)",
  fill: "#8481ec"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9155",
  "data-name": "Path 9155",
  d: "M7.34,231.709A180.8,180.8,0,0,1,61,45.45a178.79,178.79,0,0,1,44.672-29.027,181,181,0,0,1,24.4-9.088c95.847-28.067,196.342,26.87,224.41,122.718a179.969,179.969,0,0,1,6.994,39.97c-22.275-14.837-45.307-43.126-57.622-53.57C281.152,97.2,252.8,81.087,223.2,84.259c-28.115,3.029-53.356,23.06-81.582,21.2-11.114-.71-22.164-4.869-33.1-2.867-17.965,3.279-29.114,21.914-32.5,39.843-3.433,17.9-1.487,36.544-5.269,54.383-5.916,27.762-26.517,51.932-52.9,62.3A178.037,178.037,0,0,1,7.34,231.709Z",
  transform: "translate(0 0)",
  fill: "#7f7ffb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9156",
  "data-name": "Path 9156",
  d: "M.379,15.277C-1.366,9.322,3.083,2.78,10.311.663s14.5,1,16.244,6.95-2.7,12.5-9.932,14.611S2.123,21.232.379,15.277Z",
  transform: "translate(125.095 301.721)",
  fill: "#7875f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9157",
  "data-name": "Path 9157",
  d: "M.379,15.277C-1.366,9.322,3.079,2.78,10.307.663s14.5,1,16.244,6.95-2.7,12.5-9.928,14.611S2.123,21.232.379,15.277Z",
  transform: "translate(68.904 209.997)",
  fill: "#9f9fff",
  opacity: 0.48
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9158",
  "data-name": "Path 9158",
  d: "M.377,15.279C-1.363,9.324,3.082,2.781,10.31.664s14.5,1,16.244,6.947-2.7,12.5-9.932,14.615S2.122,21.23.377,15.279Z",
  transform: "translate(160.245 144.86)",
  fill: "#9f9fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9159",
  "data-name": "Path 9159",
  d: "M.379,15.275C-1.366,9.32,3.079,2.778,10.307.665s14.5.991,16.244,6.947-2.7,12.5-9.928,14.615S2.119,21.231.379,15.275Z",
  transform: "translate(207.263 32.146)",
  fill: "#6c64df",
  opacity: 0.37
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9160",
  "data-name": "Path 9160",
  d: "M.19,7.639C-.683,4.662,1.538,1.391,5.153.332s7.248.5,8.12,3.473-1.352,6.249-4.964,7.307S1.058,10.617.19,7.639Z",
  transform: "translate(21.094 159.978)",
  fill: "#6c64df",
  opacity: 0.37
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9161",
  "data-name": "Path 9161",
  d: "M.884,35.01A21.761,21.761,0,0,1,0,29.027,178.789,178.789,0,0,1,44.672,0c8.854,2.446,15.9,8.441,18.35,16.811,4.132,14.119-6.439,29.65-23.564,34.665C22.3,56.5,5.019,49.125.884,35.01Z",
  transform: "translate(60.997 16.423)",
  fill: "#6c64df",
  opacity: 0.37
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9162",
  "data-name": "Path 9162",
  d: "M.191,6.079A4.745,4.745,0,1,1,6.079,9.3,4.75,4.75,0,0,1,.191,6.079Z",
  transform: "translate(98.384 304.472)",
  fill: "#7875f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9163",
  "data-name": "Path 9163",
  d: "M.193,6.079A4.745,4.745,0,1,1,6.077,9.3,4.746,4.746,0,0,1,.193,6.079Z",
  transform: "translate(36.515 93.191)",
  fill: "#6c64df",
  opacity: 0.37
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9164",
  "data-name": "Path 9164",
  d: "M.191,6.077A4.745,4.745,0,1,1,6.079,9.3,4.744,4.744,0,0,1,.191,6.077Z",
  transform: "translate(45.616 141.157)",
  fill: "#6c64df",
  opacity: 0.37
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9165",
  "data-name": "Path 9165",
  d: "M0,4.746A4.744,4.744,0,1,1,4.742,9.492,4.743,4.743,0,0,1,0,4.746Z",
  transform: "translate(27.66 222.741)",
  fill: "#9f9fff",
  opacity: 0.44
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9166",
  "data-name": "Path 9166",
  d: "M.193,6.077A4.745,4.745,0,1,1,6.077,9.3,4.74,4.74,0,0,1,.193,6.077Z",
  transform: "translate(91.096 162.658)",
  fill: "#9f9fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9167",
  "data-name": "Path 9167",
  d: "M.193,6.077A4.745,4.745,0,1,1,6.081,9.3,4.74,4.74,0,0,1,.193,6.077Z",
  transform: "translate(160.43 324.692)",
  fill: "#7875f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9168",
  "data-name": "Path 9168",
  d: "M.193,6.077A4.745,4.745,0,1,1,6.08,9.3,4.74,4.74,0,0,1,.193,6.077Z",
  transform: "translate(151.061 217.219)",
  fill: "#7875f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9169",
  "data-name": "Path 9169",
  d: "M.191,6.081A4.745,4.745,0,1,1,6.079,9.3,4.749,4.749,0,0,1,.191,6.081Z",
  transform: "translate(121.191 248.55)",
  fill: "#7875f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9170",
  "data-name": "Path 9170",
  d: "M.191,6.079A4.745,4.745,0,1,1,6.079,9.3,4.75,4.75,0,0,1,.191,6.079Z",
  transform: "translate(287.344 234.012)",
  fill: "#7875f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9171",
  "data-name": "Path 9171",
  d: "M0,4.746A4.744,4.744,0,1,1,4.742,9.492,4.746,4.746,0,0,1,0,4.746Z",
  transform: "translate(338.869 169.671)",
  fill: "#7875f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9172",
  "data-name": "Path 9172",
  d: "M0,5.525A9.689,9.689,0,0,1,6.058.4a9.914,9.914,0,0,1,12.3,6.729,9.755,9.755,0,0,1,.174,4.825A174.709,174.709,0,0,1,0,5.525Z",
  transform: "translate(112.358 342.717)",
  fill: "#7875f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9173",
  "data-name": "Path 9173",
  d: "M.193,6.079A4.745,4.745,0,1,1,6.081,9.3,4.746,4.746,0,0,1,.193,6.079Z",
  transform: "translate(137.259 43.285)",
  fill: "#6c64df",
  opacity: 0.37
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9174",
  "data-name": "Path 9174",
  d: "M.191,6.077A4.745,4.745,0,1,1,6.079,9.3,4.744,4.744,0,0,1,.191,6.077Z",
  transform: "translate(188.776 18.312)",
  fill: "#6c64df",
  opacity: 0.37
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9175",
  "data-name": "Path 9175",
  d: "M.262,8.283a6.466,6.466,0,1,1,8.021,4.389A6.463,6.463,0,0,1,.262,8.283Z",
  transform: "translate(158.52 55.239)",
  fill: "#6c64df",
  opacity: 0.37
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9176",
  "data-name": "Path 9176",
  d: "M.264,8.287a6.466,6.466,0,1,1,8.021,4.385A6.466,6.466,0,0,1,.264,8.287Z",
  transform: "translate(138.425 178.223)",
  fill: "#9f9fff",
  opacity: 0.44
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9177",
  "data-name": "Path 9177",
  d: "M.389,12.264a9.571,9.571,0,1,1,11.875,6.495A9.565,9.565,0,0,1,.389,12.264Z",
  transform: "translate(31.676 188.757)",
  fill: "#6c64df",
  opacity: 0.37
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9178",
  "data-name": "Path 9178",
  d: "M.387,12.264a9.572,9.572,0,1,1,11.879,6.5A9.574,9.574,0,0,1,.387,12.264Z",
  transform: "translate(245.334 223.114)",
  fill: "#7875f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9179",
  "data-name": "Path 9179",
  d: "M.193,6.081A4.745,4.745,0,1,1,6.081,9.3,4.746,4.746,0,0,1,.193,6.081Z",
  transform: "translate(60.102 73.579)",
  fill: "#6c64df",
  opacity: 0.37
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9180",
  "data-name": "Path 9180",
  d: "M.271,8.587A6.7,6.7,0,1,1,8.59,13.139,6.7,6.7,0,0,1,.271,8.587Z",
  transform: "translate(108.685 283.797)",
  fill: "#7875f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9181",
  "data-name": "Path 9181",
  d: "M.271,8.587A6.7,6.7,0,1,1,8.59,13.139,6.7,6.7,0,0,1,.271,8.587Z",
  transform: "translate(216.958 95.433)",
  fill: "#9f9fff"
}));

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_520",
  "data-name": "Ellipse 520",
  cx: 41.5,
  cy: 9.5,
  rx: 41.5,
  ry: 9.5,
  transform: "translate(154 707)",
  fill: "#6e6bcb",
  opacity: 0.82
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2215",
  "data-name": "Group 2215",
  transform: "translate(99.467 526.658)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9194",
  "data-name": "Path 9194",
  d: "M3.386,4.161S.474,32.172,0,37.039c.821,2.448,8.027,4.294,11.208,1.755L17.372,0Z",
  transform: "translate(95.968 147.833) rotate(-13)",
  fill: "#e96524"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9203",
  "data-name": "Path 9203",
  d: "M3.386,35.852S.474,7.84,0,2.973C.821.525,8.027-1.321,11.208,1.218l6.164,38.795Z",
  transform: "translate(87.458 185.365) rotate(-167)",
  fill: "#e96524"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9195",
  "data-name": "Path 9195",
  d: "M1,0C.705,3.4.224,12.5,0,14.811c.821,2.448,8.027,4.294,11.208,1.756l2.7-14.944C11.519,4.292,3.067,3.426,1,0",
  transform: "translate(100.968 169.492) rotate(-13)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9204",
  "data-name": "Path 9204",
  d: "M1,17.784C.705,14.38.224,5.282,0,2.973.821.525,8.027-1.321,11.208,1.217l2.7,14.944C11.519,13.492,3.067,14.358,1,17.784",
  transform: "translate(87.458 185.365) rotate(-167)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9196",
  "data-name": "Path 9196",
  d: "M0,10.161c.635,3.289,13.088,8.375,21.537,6.226,4.08-6.787.974-12.7-3.627-14.693C12.2-.777,8.079.989,4.484,4.94,3.365,5.46,3.347,3.865,3.607,0,1.529,1.217.136,6.3,0,10.161",
  transform: "translate(99.876 178.851) rotate(-13)",
  fill: "#808251"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9205",
  "data-name": "Path 9205",
  d: "M0,6.739C.635,3.451,13.088-1.635,21.537.513c4.08,6.787.974,12.7-3.627,14.693-5.714,2.471-9.832.705-13.427-3.247-1.12-.519-1.137,1.075-.877,4.94C1.529,15.683.136,10.6,0,6.739",
  transform: "translate(88.749 193.864) rotate(-167)",
  fill: "#808251"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9197",
  "data-name": "Path 9197",
  d: "M2.1,9.959A12.263,12.263,0,0,1,0,9.194C.193,4.507,2.046.673,7.845.018a8.234,8.234,0,0,1,6.534,2.853,9.424,9.424,0,0,1,1.352,8.071c-5.057.093-9.9-.069-13.626-.982",
  transform: "translate(107.449 179.039) rotate(-13)",
  fill: "#ebe8e3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9206",
  "data-name": "Path 9206",
  d: "M2.1,1.005A12.263,12.263,0,0,0,0,1.77c.193,4.687,2.046,8.521,7.845,9.176a8.234,8.234,0,0,0,6.534-2.853A9.424,9.424,0,0,0,15.731.023C10.674-.07,5.828.092,2.1,1.005",
  transform: "translate(82.512 188.268) rotate(-167)",
  fill: "#ebe8e3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9198",
  "data-name": "Path 9198",
  d: "M1.845,8.725A10.722,10.722,0,0,1,0,8.056C.17,3.95,1.793.591,6.873.016a7.207,7.207,0,0,1,5.722,2.5,8.253,8.253,0,0,1,1.187,7.07A49.591,49.591,0,0,1,1.845,8.725",
  transform: "translate(109.097 178.758) rotate(-13)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9207",
  "data-name": "Path 9207",
  d: "M1.845.882A10.722,10.722,0,0,0,0,1.551c.17,4.106,1.793,7.464,6.873,8.04A7.207,7.207,0,0,0,12.6,7.09,8.253,8.253,0,0,0,13.782.02,49.591,49.591,0,0,0,1.845.882",
  transform: "translate(81.169 186.664) rotate(-167)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9199",
  "data-name": "Path 9199",
  d: "M0,3.96c.635,3.289,13.088,8.374,21.537,6.226a13.7,13.7,0,0,0,1.536-3.557c-5.061.092-9.907-.069-13.633-.984A21.068,21.068,0,0,1,.507,0,23.055,23.055,0,0,0,0,3.96",
  transform: "translate(101.271 184.893) rotate(-13)",
  fill: "#715f51"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9210",
  "data-name": "Path 9210",
  d: "M5.974,0,25.041,8.84l2.6,3.127.182,2.609L13.275,33.853l-5.531-3.54L17.7,14.6,0,9.735Z",
  transform: "translate(114.8 94.191) rotate(7)",
  fill: "#ff6f00"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9208",
  "data-name": "Path 9208",
  d: "M0,6.739C.635,3.451,13.088-1.635,21.537.513A13.7,13.7,0,0,1,23.074,4.07c-5.061-.092-9.907.069-13.633.984A21.068,21.068,0,0,0,.507,10.7,23.055,23.055,0,0,1,0,6.739",
  transform: "translate(88.749 193.864) rotate(-167)",
  fill: "#715f51"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9186",
  "data-name": "Path 9186",
  d: "M14.225,35.366c5.107,27.4,33.292,41.563,57.423,26,0,0,9.926-6.086,15.481-16.391,3.47-6.44-4.32-6.951-4.32-6.951s-10.26,11.226-22.643,8.794c-4.878-.958-8.822-13.234-11.215-19.337C41.372,8.16,32.376,6.894,32.376,6.894s4.7,6.259,2.4,7.928c0,0-12.5-16.617-34.776-14.663,0,0,8.272,7.128,9.531,10.689,0,0-5.523-1.778-8.571-.418C12.729,16.36,14.518,27.237,14.225,35.366",
  transform: "matrix(0.978, 0.208, -0.208, 0.978, 14.099, 70.566)",
  fill: "#ff6f00"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9187",
  "data-name": "Path 9187",
  d: "M19.374,16.682C20.809,23.24,29.408,28.322,32.9,30.7c-.356-3.691,2.091-8.626,1.254-10.783,4.795,1.1,14.127,9.185,13.332,7.066C40.286,7.777,31.521,6.6,31.521,6.6s4.524,6.2,2.261,7.891C33.782,14.492,21.756-1.973,0,.2c0,0,8,7.034,9.192,10.576,0,0-5.371-1.72-8.359-.332C9.756,14.973,13.55,22.926,13.564,32.807c1.633-5.139,5.5-11.94,5.81-16.125",
  transform: "translate(14.22 70.649) rotate(11)",
  fill: "#c4502b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9191",
  "data-name": "Path 9191",
  d: "M1006.23,1109.5c.58,2.163-1.711,6.727-2.228,12.338a75.851,75.851,0,0,1-1.881,11.759s-11.979-.459-19.8-5.032c0,0,5.449-24.892,5.17-26.175s18.742,0,18.742,0",
  transform: "translate(-908.74 -971.359)",
  fill: "#4d412b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9209",
  "data-name": "Path 9209",
  d: "M.287,13.163C-.861,16.13,1.435,23.937,7.2,24.189c5.3.232,10.944-17.56,11.777-19.226.878-1.756-8.544-5.115-12.2-4.958",
  transform: "matrix(-0.017, 1, -1, -0.017, 129.12, 91.3)",
  fill: "#ffc22b",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9192",
  "data-name": "Path 9192",
  d: "M1033.533,1102.264c-1.025,3.825,1.139,23.55,3.032,30.56,0,0,13.7-.459,21.527-5.032,0,0-6.742-25.861-6.463-27.144s-12.6,1.616-12.6,1.616",
  transform: "translate(-938.952 -970.587)",
  fill: "#4d412b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9193",
  "data-name": "Path 9193",
  d: "M1029.946,1124.9c-.446-.191-3.78-1.163-4.385-1.843,1.522,2.022,3.177,1.981,4.012,3.229a142.667,142.667,0,0,0,2.226,21.446,18.475,18.475,0,0,0,15.947-3.11c-4.855,2.349-10.9,3.028-14.922,1.853-1.219-3.111-2.878-21.575-2.878-21.575",
  transform: "translate(-934.186 -986.125)",
  fill: "#3f3321"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9185",
  "data-name": "Path 9185",
  d: "M-2995.463,14.477s-3.354,43.3-2.624,47.179,46.4,2.262,43.111-1.616-.147-41.362-9.5-43.948S-2995.463,14.477-2995.463,14.477Z",
  transform: "translate(3074.096 71.636)",
  fill: "#ffc22b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7494",
  "data-name": "Path 7494",
  d: "M0,24.64S6.156,6.881,8.737,5.4c0,0-1.88-3.071-.49-3.746s2.833,1.97,2.833,1.97S10.953-.029,12.329,0,13.58,4.095,13.58,4.095s1.977-2.7,3-.35c.348.8-2.084,2.943-2.084,2.943S22.86,17.369,20.42,35.662,0,24.64,0,24.64Z",
  transform: "matrix(0.934, 0.358, -0.358, 0.934, 124.453, 0)",
  fill: "#ff6f00"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7495",
  "data-name": "Path 7495",
  d: "M10.553,8.638a19.284,19.284,0,0,0-1.39-2.116s2.432-2.094,2.084-2.87c-1.026-2.289-3,.341-3,.341S8.369.029,6.993,0,5.745,3.536,5.745,3.536,4.3.955,2.912,1.614s.49,3.653.49,3.653A22.512,22.512,0,0,0,1.43,7.617L0,10.8,4.291,7.935l2.225,3.02L8.265,8.094l3.815,4.133Z",
  transform: "matrix(0.934, 0.358, -0.358, 0.934, 129.687, 1.883)",
  fill: "#ec6117"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7496",
  "data-name": "Path 7496",
  d: "M0,12.078S3.988-1.116,6.454.076s4.652,11.8,3.763,18.552S0,12.078,0,12.078Z",
  transform: "matrix(0.934, 0.358, -0.358, 0.934, 126.676, 16.585)",
  fill: "#a12814",
  opacity: 0.21
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7497",
  "data-name": "Path 7497",
  d: "M27.575,11.825S11.077,2.571,7.91,3.178c0,0-.3-3.562-1.93-3.144S4.763,3.405,4.763,3.405,2.576.571,1.4,1.51,2.89,5.424,2.89,5.424-.518,4.713.068,7.162c.2.831,3.657.824,3.657.824S3.19,21.594,16.8,33.726,27.575,11.825,27.575,11.825Z",
  transform: "matrix(0.934, 0.358, -0.358, 0.934, 57.157, 6.248)",
  fill: "#ff6f00"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7498",
  "data-name": "Path 7498",
  d: "M4.082,11.426a20.344,20.344,0,0,1-.167-2.772S.28,8.661.071,7.761C-.545,5.107,3.038,5.877,3.038,5.877S.24,2.654,1.474,1.636,5.006,3.689,5.006,3.689,4.573.49,6.286.037,8.315,3.444,8.315,3.444A4.5,4.5,0,0,1,9.9,3.519l3.575,1.408-4.05.963L9.111,9.744,5.373,9.9v6.423Z",
  transform: "matrix(0.934, 0.358, -0.358, 0.934, 57.073, 5.881)",
  fill: "#ec6117"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7499",
  "data-name": "Path 7499",
  d: "M12.274,5.412S1.415-2.156.175.607,4.525,14.353,10,19.772,12.274,5.412,12.274,5.412Z",
  transform: "matrix(0.934, 0.358, -0.358, 0.934, 60.761, 20.185)",
  fill: "#a12814",
  opacity: 0.21
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7555",
  "data-name": "Path 7555",
  d: "M24.795,9.21S17.715,6.865,20.7,4.45c1.529-1.236-3.839.744-4.666,3.118,0,0-2.779-3.15-.738-5.344-2.767.749-7.8,4.214-8.566,8.263,0,0-.047-9.228,3.48-10.488C1.309,3.179-.383,13.2.065,14.527c1.575,4.661,24.193,1.2,24.729-5.317",
  transform: "matrix(0.934, 0.358, -0.358, 0.934, 92.404, 7.989)",
  fill: "#ff6f00"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7556",
  "data-name": "Path 7556",
  d: "M10.3,58.267c7.941,18.127,14.392,15.365,32.574,9.962S77.529,59.411,73.97,39.944C70.233,19.509,58.134-7.271,27.282,1.828-8.51,12.385-2.725,41.3,8.983,59.25",
  transform: "matrix(0.934, 0.358, -0.358, 0.934, 76.832, 7.874)",
  fill: "#ff6f00"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7558",
  "data-name": "Path 7558",
  d: "M8.64,48.177S-7.781,28.726,4.654,13.92c5.613-6.683,15.009-3.727,16.264-3.031,0,0,5.59-17.39,22.823-8.216a19.6,19.6,0,0,1,8.642,8.192c3.465,5.77,7.9,15.108,4.347,20.536C51.315,39.664,8.64,48.177,8.64,48.177Z",
  transform: "matrix(0.934, 0.358, -0.358, 0.934, 80.681, 18.346)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_513",
  "data-name": "Ellipse 513",
  cx: 0.53,
  cy: 0.568,
  rx: 0.53,
  ry: 0.568,
  transform: "translate(85.242 57.758) rotate(14.684)",
  fill: "#fefefe"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7567",
  "data-name": "Path 7567",
  d: "M1.607,29.507s11.521-.428,13.952.647c0,0,13.388-11.225,24.695-11.166,0,0,17.323-13.553,26.345-8.984,0,0,6.243-8.863,10.234-10l.553,6.637,4.421-2.113-.419,6.207,4.692-1.412s-4.426,27.1-37.215,38.174S3.47,43.7,1.74,42.351s4.421-2.113,4.421-2.113L0,35.77s4.071-1.978,5.744-1.819S1.607,29.507,1.607,29.507Z",
  transform: "matrix(0.934, 0.358, -0.358, 0.934, 66.085, 31.253)",
  fill: "#ffe14e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7568",
  "data-name": "Path 7568",
  d: "M.152,4.941c.621,1.387,4.433,2.04,5.595,1.52,1.122-.5,3.213-3.8,2.592-5.184S5.382-.414,3.122.6-.468,3.553.152,4.941",
  transform: "matrix(0.934, 0.358, -0.358, 0.934, 95.613, 58.862)",
  fill: "#d98c19"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_517",
  "data-name": "Ellipse 517",
  cx: 6.118,
  cy: 1.733,
  rx: 6.118,
  ry: 1.733,
  transform: "matrix(0.988, -0.154, 0.154, 0.988, 70.417, 68.106)",
  fill: "#fa9785",
  opacity: 0.36
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_518",
  "data-name": "Ellipse 518",
  cx: 5.625,
  cy: 2.061,
  rx: 5.625,
  ry: 2.061,
  transform: "translate(112.844 64.406) rotate(9)",
  fill: "#fdc662",
  opacity: 0.9
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7561",
  "data-name": "Path 7561",
  d: "M3.709,1.972a5.042,5.042,0,0,1,5.411-.18C7.286.047,4.861-.732,2.255.881-3.832,4.648,4.332,15.1,4.332,15.1s1.209.856,1.6.809C4.029,13.092-1.141,4.974,3.709,1.972Z",
  transform: "matrix(0.934, 0.358, -0.358, 0.934, 79.596, 44.309)",
  fill: "#58271b",
  opacity: 0.59
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9182",
  "data-name": "Path 9182",
  d: "M3.709,1.972a5.042,5.042,0,0,1,5.411-.18C7.286.047,4.861-.732,2.255.881-3.832,4.648,4.332,15.1,4.332,15.1s.238-.013.632-.059C3.058,12.224-1.141,4.974,3.709,1.972Z",
  transform: "matrix(0.809, 0.588, -0.588, 0.809, 108.427, 42.778)",
  fill: "#58271b",
  opacity: 0.59
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7562",
  "data-name": "Path 7562",
  d: "M4.583,15.1S-3.887,4.647,2.2.885s11.15,5.438,10.035,9.594S4.583,15.1,4.583,15.1Z",
  transform: "matrix(0.934, 0.358, -0.358, 0.934, 80.362, 45.389)",
  fill: "#fefefe"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9183",
  "data-name": "Path 9183",
  d: "M4.583,15.1S-3.887,4.647,2.2.885s11.15,5.438,10.035,9.594S4.583,15.1,4.583,15.1Z",
  transform: "matrix(0.809, 0.588, -0.588, 0.809, 108.888, 44.02)",
  fill: "#fefefe"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7564",
  "data-name": "Path 7564",
  d: "M6.051,3.456c1.318,2.372,1.269,5-.11,5.86-1.626,1.019-3.565-.358-4.883-2.731S-.41,1.091.969.227,4.733,1.084,6.051,3.456Z",
  transform: "matrix(0.934, 0.358, -0.358, 0.934, 84.581, 48.556)",
  fill: "#806351"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9184",
  "data-name": "Path 9184",
  d: "M6.051,3.456c1.318,2.372,1.269,5-.11,5.86-1.626,1.019-3.565-.358-4.883-2.731S-.41,1.091.969.227,4.733,1.084,6.051,3.456Z",
  transform: "matrix(0.809, 0.588, -0.588, 0.809, 112.12, 48.349)",
  fill: "#806351"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9188",
  "data-name": "Path 9188",
  d: "M-2982.5-21.333s4.251,8.725,14.024,4.133",
  transform: "translate(3070.932 89.053)",
  fill: "none",
  stroke: "#1a1a1a",
  strokeLinecap: "round",
  strokeWidth: 2,
  opacity: 0.53
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9202",
  "data-name": "Path 9202",
  d: "M-2935.223,72.667l21.955.833-13.283,4.014Z",
  transform: "translate(3039.875 44.953)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9189",
  "data-name": "Path 9189",
  d: "M-3054,25.282h56.8l12.126,36.838h-58.719Z",
  transform: "translate(3094.678 61.963)",
  fill: "#616ca5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9190",
  "data-name": "Path 9190",
  d: "M-2971.689,1h3.727l12.005,36.2-2.89.637Z",
  transform: "translate(3068.361 86.245)",
  fill: "#c5c2c2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7560",
  "data-name": "Path 7560",
  d: "M7.943,1.124S3.238-1.725,0,1.65",
  transform: "translate(108.886 34.376) rotate(16)",
  fill: "none",
  stroke: "#e9c785",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7559",
  "data-name": "Path 7559",
  d: "M5.577,0S.169,1.006,0,5.681",
  transform: "matrix(0.891, 0.454, -0.454, 0.891, 79.776, 36.278)",
  fill: "none",
  stroke: "#e9c785",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9201",
  "data-name": "Path 9201",
  d: "M-2924.958,69.6l16.5-2.262V69.6l-17.042,3.315Z",
  transform: "translate(3035.189 51.095)",
  fill: "#c5c2c2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9211",
  "data-name": "Path 9211",
  d: "M3.169,0S-1.6,2.536.565,4.254s7.787,7.949,11.243,8.13,1.885-2.893,1.885-2.893L6.18,4.254Z",
  transform: "translate(117.232 124.065) rotate(3)",
  fill: "#ff6f00"
}), /*#__PURE__*/React.createElement("path", {
  id: "Union_1",
  "data-name": "Union 1",
  d: "M3.442,13.674.075,3.312a1.519,1.519,0,0,1,2.89-.94l1.9,5.859L8.484.817A1.454,1.454,0,1,1,11.1,2.092L8.874,6.652,14.4,9.592a1.4,1.4,0,1,1-1.313,2.47L7.647,9.168,6.218,12.1q-.027.056-.058.108l.172.529a1.519,1.519,0,1,1-2.89.939Z",
  transform: "matrix(0.995, 0.105, -0.105, 0.995, 66.427, 95.176)",
  fill: "#d9d9d9",
  opacity: 0.97
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_528",
  "data-name": "Rectangle 528",
  width: 2.576,
  height: 4.293,
  rx: 1.288,
  transform: "matrix(0.788, -0.616, 0.616, 0.788, 63.214, 121.452)",
  fill: "#ff6f00"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9710",
  "data-name": "Path 9710",
  d: "M1.257,0a1.283,1.283,0,0,1,1.31,1.164l.142,6.064a1.154,1.154,0,0,1-1.257,1.11A1.283,1.283,0,0,1,.142,7.175L0,1.111A1.154,1.154,0,0,1,1.257,0Z",
  transform: "matrix(0.985, -0.174, 0.174, 0.985, 66.385, 116.57)",
  fill: "#ff6f00"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9709",
  "data-name": "Path 9709",
  d: "M1.261,0A1.283,1.283,0,0,1,2.568,1.182l.151,7.729a1.173,1.173,0,0,1-1.261,1.137A1.283,1.283,0,0,1,.151,8.866L0,1.137A1.173,1.173,0,0,1,1.261,0Z",
  transform: "matrix(0.985, -0.174, 0.174, 0.985, 69.516, 114.883)",
  fill: "#ff6f00"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_531",
  "data-name": "Rectangle 531",
  width: 2.576,
  height: 8.586,
  rx: 1.288,
  transform: "translate(73.608 115.467) rotate(-5)",
  fill: "#ff6f00"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_535",
  "data-name": "Rectangle 535",
  width: 1.906,
  height: 6.355,
  rx: 0.953,
  transform: "translate(131.821 134.406) rotate(116)",
  fill: "#ff6f00"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_532",
  "data-name": "Rectangle 532",
  width: 1.717,
  height: 6.01,
  rx: 0.859,
  transform: "matrix(0.995, 0.105, -0.105, 0.995, 77.62, 117.564)",
  fill: "#ff6f00"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9708",
  "data-name": "Path 9708",
  d: "M2136.833-459.234s.2,1.3,3.005,1.623a22.368,22.368,0,0,0,8.228-.325c3.1-.706,2.755-2.824,2.755-2.824l-4.4-2.24-6.582.828s.2,2.167-.823,2.581A5.861,5.861,0,0,1,2136.833-459.234Z",
  transform: "translate(-2071.898 582.866)",
  fill: "#ff6f00"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9711",
  "data-name": "Path 9711",
  d: "M4.476,0A4.315,4.315,0,0,1,8.953,4.132c0,2.282-3.923,5.608-6.395,5.608S0,6.414,0,4.132A4.315,4.315,0,0,1,4.476,0Z",
  transform: "translate(133.175 105.706) rotate(3)",
  fill: "#ff6f00"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_533",
  "data-name": "Rectangle 533",
  width: 2.542,
  height: 6.99,
  rx: 1.271,
  transform: "translate(129.651 129.17) rotate(115)",
  fill: "#ff6f00"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2216",
  "data-name": "Group 2216",
  transform: "translate(58.145 673.566) rotate(-21)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9046",
  "data-name": "Path 9046",
  d: "M34.482,4.313c0,2.385-7.722,4.325-17.241,4.325S0,6.7,0,4.313,7.722,0,17.241,0,34.482,1.928,34.482,4.313Z",
  transform: "translate(0 0)",
  fill: "#b6bffa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9047",
  "data-name": "Path 9047",
  d: "M34.482,0V53.149c0,2.238-7.722,4.048-17.241,4.048S0,55.387,0,53.149V0C0,2.238,7.722,4.059,17.241,4.059S34.482,2.238,34.482,0Z",
  transform: "translate(0 3.512)",
  fill: "url(#linear-gradient-2)"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2217",
  "data-name": "Group 2217",
  transform: "matrix(0.946, -0.326, 0.326, 0.946, 41.308, 627.669)",
  opacity: 0.17
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1060",
  "data-name": "Group 1060",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2811",
  "data-name": "Path 2811",
  d: "M9.6,0C4.371.075.073,3.985,0,8.735s4.11,8.541,9.341,8.467,9.529-3.983,9.6-8.734S14.832-.073,9.6,0ZM9.071,12.065A3.533,3.533,0,0,1,5.356,8.579,3.791,3.791,0,0,1,9.178,4.987a3.533,3.533,0,0,1,3.715,3.486A3.791,3.791,0,0,1,9.071,12.065Z",
  fill: "#fcfcff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2812",
  "data-name": "Path 2812",
  d: "M9.6,0C4.371.075.073,3.985,0,8.735s4.11,8.541,9.341,8.467,9.53-3.983,9.6-8.734S14.833-.073,9.6,0ZM9.071,12.065A3.533,3.533,0,0,1,5.356,8.579,3.791,3.791,0,0,1,9.178,4.987a3.533,3.533,0,0,1,3.715,3.486A3.79,3.79,0,0,1,9.071,12.065Z",
  transform: "translate(18.661 18.286)",
  fill: "#fcfcff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2813",
  "data-name": "Path 2813",
  d: "M.45,25.472C.639,25.19,24.726.742,26.214.131s3.646,1.063,3.843,1.977S4.586,28.479,3.52,29.084-1.279,28.052.45,25.472Z",
  transform: "translate(3.637 3.056)",
  fill: "#fcfcff"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1957",
  "data-name": "Group 1957",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1955",
  "data-name": "Group 1955",
  opacity: 0.4
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9223",
  "data-name": "Path 9223",
  d: "M452.751,302.257a14.19,14.19,0,0,1-1.647,6.851l-.008-.005-12.558-6.71-.1-.065-.182-14.14.559-.047A14.3,14.3,0,0,1,452.751,302.257Z",
  transform: "translate(-424.137 -288.133)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9224",
  "data-name": "Path 9224",
  d: "M414.908,349.531c-.034.07-.07.138-.109.208a14.31,14.31,0,0,1-25.439-.66l12.831-6.214.055-.114.1.065,12.558,6.71Z",
  transform: "translate(-387.94 -328.556)",
  fill: "#778cff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9225",
  "data-name": "Path 9225",
  d: "M398.577,288.121l-.559.047.182,14.14-.055.114-12.831,6.214a14.308,14.308,0,0,1,12.7-20.521C398.206,288.113,398.39,288.113,398.577,288.121Z",
  transform: "translate(-383.895 -288.114)",
  fill: "#778cff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1956",
  "data-name": "Group 1956",
  opacity: 0.36
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9226",
  "data-name": "Path 9226",
  d: "M410.754,309.3a14.309,14.309,0,1,1-12.735-21.181",
  transform: "translate(-383.895 -288.118)",
  fill: "none",
  stroke: "#706969",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9227",
  "data-name": "Path 9227",
  stroke: "#706969",
  d: "M438.26,288.116c.187,0,.371,0,.559.005A14.306,14.306,0,0,1,451.1,309.088c-.034.07-.07.138-.109.208",
  fill: "none",
  transform: "translate(-424.137 -288.114)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  strokeDasharray: 4
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_9",
  "data-name": "Line 9",
  x2: 12.558,
  y2: 6.71,
  transform: "translate(14.401 14.259)",
  fill: "none",
  stroke: "#706969",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9228",
  "data-name": "Path 9228",
  d: "M389.3,349.412l.016-.008,12.831-6.214",
  transform: "translate(-387.896 -328.882)",
  fill: "none",
  stroke: "#706969",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_10",
  "data-name": "Line 10",
  x1: 0.182,
  y1: 14.14,
  transform: "translate(14.123 0.054)",
  fill: "none",
  stroke: "#706969",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_10546",
  "data-name": "Path 10546",
  d: "M341.211,248.247a1.564,1.564,0,0,0-1.979-.674l-.233.075a1.13,1.13,0,0,0-.554,1.886c-.066,2.116-4.485,3.29-5.893,3.791-1.87.665-3.88,1.328-5.229,2.8-1.755,1.917-2.223,4.608-.157,6.435.568.5,1.493.017,1.179-.713a3.059,3.059,0,0,1,1.073-4.04c1.6,3.03,4.684,9.03,3.749,9.207a1.351,1.351,0,0,0,.11,2.687c2.911.271,3.828-2.452,3.133-4.673a22.178,22.178,0,0,0-5.212-8.269c.805-.382,1.7-.729,2.629-1.072.324,3.939,5.059,13.773,10.025,9.958,1.536-1.181-.387-3.161-1.961-2.16-1.268.808-5.221-6.469-6.672-8.314C339.027,253.752,342.644,252.146,341.211,248.247Z",
  transform: "translate(-246.89 321.105)",
  fill: "#fff",
  opacity: 0.23
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2224",
  "data-name": "Group 2224",
  transform: "matrix(0.978, 0.208, -0.208, 0.978, 255.801, 536.158)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1964",
  "data-name": "Group 1964",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9238",
  "data-name": "Path 9238",
  d: "M8.909,48.324C.083,43.167-3.776,23.675,4.813,11.217S36.676-4.189,48.062,6.8s7.691,33.959-3,40.557S19,54.218,8.909,48.324Z",
  transform: "translate(0.979 0)",
  fill: "#6397ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9239",
  "data-name": "Path 9239",
  d: "M2.679,0,0,12.86,12.456,3.405Z",
  transform: "translate(15.965 49.128)",
  fill: "#6397ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9240",
  "data-name": "Path 9240",
  d: "M13.262,11.454A18.542,18.542,0,0,1,0,0S.067,5.023,3.483,8.071,13.262,11.454,13.262,11.454Z",
  transform: "translate(0 39.282)",
  fill: "#6397ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9241",
  "data-name": "Path 9241",
  d: "M7.435,11.319A19.028,19.028,0,0,0,0,0S5.24,2.863,6.865,6.48,7.435,11.319,7.435,11.319Z",
  transform: "translate(49.143 4.921)",
  fill: "#6397ff"
})));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2225",
  "data-name": "Group 2225",
  transform: "matrix(0.883, 0.469, -0.469, 0.883, 277.955, 552.918)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9221",
  "data-name": "Path 9221",
  d: "M12.576,1.758C10.836-.48,7.26-.169,4.794.457,1.8,1.217-.129,3.22.007,6.362a.823.823,0,0,0,1.645,0C1.828,3.956,5.07,2.808,7.159,3.093c1.054.144,2.993,1.12,3.14,2.426.069.612-1.167,1.75-1.609,2.178C6.881,9.441,4.559,10.42,3.229,12.664c-1.723,2.905-.712,7.72,3.278,7.67,1.315-.017,2.056-2.031.717-2.648-5.016-2.306,3.655-7.154,5.123-9.224C13.721,6.528,14.115,3.738,12.576,1.758Z",
  transform: "translate(0 0)",
  fill: "#ecf2ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9222",
  "data-name": "Path 9222",
  d: "M2.738.242A1.789,1.789,0,0,0,.076,2.21,1.449,1.449,0,0,0,.5,2.874a1.564,1.564,0,0,0,1.128.7A1.816,1.816,0,0,0,2.738.242Z",
  transform: "translate(7.444 22.181)",
  fill: "#ecf2ff"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_10543",
  "data-name": "Path 10543",
  d: "M49.947,74.369c0,4.851-11.173,8.767-24.974,8.767S0,79.219,0,74.369l.683-2.024L24.974,0l24.29,72.344Z",
  transform: "matrix(0.883, 0.469, -0.469, 0.883, 305.262, 640.6)",
  fill: "url(#linear-gradient-3)"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2218",
  "data-name": "Group 2218",
  transform: "translate(259.788 623.36)",
  opacity: 0.26
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2190",
  "data-name": "Group 2190",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9712",
  "data-name": "Path 9712",
  d: "M33.381,134.226c-1.175-.758-1.654-2.24-1.654-4.081h0c.01-3.971,2.2-9.977,6.054-16.039h0c4.911-7.653,10.761-12.908,14.653-12.973h0a3.137,3.137,0,0,1,1.71.466h0c1.174.76,1.65,2.238,1.651,4.078h0c-.007,3.969-2.2,9.975-6.05,16.042h0c-4.914,7.653-10.766,12.908-14.653,12.971h-.02a3.131,3.131,0,0,1-1.69-.465Zm5.125-19.656c-3.8,5.948-5.93,11.907-5.92,15.574h0c0,1.723.458,2.861,1.257,3.356h0a2.316,2.316,0,0,0,1.249.333h0c3.162.064,9.156-5.017,13.928-12.572h0c3.795-5.964,5.925-11.918,5.917-15.584h0c0-1.716-.458-2.854-1.255-3.353h0a2.231,2.231,0,0,0-1.247-.331h-.06c-3.175,0-9.131,5.061-13.868,12.577Z",
  transform: "translate(-24.425 -100.619)",
  fill: "#808bf2",
  stroke: "#4852b5",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9713",
  "data-name": "Path 9713",
  d: "M51.32,135.4c-3.9-.078-9.54-5.765-14.06-13.865h0c-3.263-5.922-5.059-11.7-5.064-15.662h0c0-2.2.553-3.922,1.925-4.693h0a3.042,3.042,0,0,1,1.5-.367h0c3.9.075,9.535,5.76,14.059,13.868h0l-.377.207-.378.209c-4.372-8.008-10.2-13.5-13.3-13.426h0a2.177,2.177,0,0,0-1.079.262h0c-.934.492-1.483,1.855-1.48,3.94h0c0,3.71,1.739,9.428,4.955,15.247h0c4.373,8,10.2,13.5,13.307,13.423h0a2.245,2.245,0,0,0,1.077-.261h0c.929-.5,1.483-1.861,1.48-3.943h0c0-3.708-1.738-9.425-4.957-15.242h0l.378-.209.377-.207c3.263,5.917,5.056,11.7,5.059,15.658h0c0,2.2-.549,3.917-1.92,4.7h0a3.033,3.033,0,0,1-1.477.365H51.32Z",
  transform: "translate(-24.13 -100.818)",
  fill: "#808bf2",
  stroke: "#4852b5",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9714",
  "data-name": "Path 9714",
  d: "M33.074,119.283c-3.457-1.236-5.773-2.908-5.827-5.113h0c.054-2.209,2.37-3.881,5.827-5.115h0a42.186,42.186,0,0,1,13.511-1.977h0v.861a41.425,41.425,0,0,0-13.227,1.925h0c-3.387,1.177-5.3,2.836-5.25,4.306h0c-.051,1.469,1.863,3.126,5.25,4.3h0A41.426,41.426,0,0,0,46.585,120.4h0a41.4,41.4,0,0,0,13.224-1.925h0c3.389-1.177,5.3-2.835,5.252-4.3h0c.052-1.47-1.863-3.13-5.252-4.306h0a41.4,41.4,0,0,0-13.224-1.925h0v-.861A42.179,42.179,0,0,1,60.1,109.055h0c3.456,1.234,5.775,2.906,5.826,5.115h0c-.051,2.205-2.37,3.878-5.826,5.113h0a42.228,42.228,0,0,1-13.511,1.976h0a42.235,42.235,0,0,1-13.511-1.976Z",
  transform: "translate(-27.247 -96.874)",
  fill: "#808bf2",
  stroke: "#4852b5",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_9715",
  "data-name": "Path 9715",
  d: "M37.519,112.345A2.261,2.261,0,1,1,39.78,114.6,2.26,2.26,0,0,1,37.519,112.345Z",
  transform: "translate(-20.776 -94.981)",
  fill: "#808bf2",
  stroke: "#4852b5",
  strokeWidth: 1
}));

var _ref14 = /*#__PURE__*/React.createElement("text", {
  id: "A",
  transform: "translate(315.066 642.081) rotate(11)",
  fill: "#dbdeff",
  fontSize: 71,
  fontFamily: "SegoeUI-Bold, Segoe UI",
  fontWeight: 700,
  opacity: 0.25
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "A"));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2221",
  "data-name": "Group 2221",
  transform: "translate(357.864 598.354) rotate(157)",
  opacity: 0.66
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_7842",
  "data-name": "Path 7842",
  d: "M5.365.365l-.308,2.1A.318.318,0,0,0,5.23,2.8l1.9.942a.318.318,0,0,1-.088.6l-2.093.356a.318.318,0,0,0-.261.267l-.308,2.1a.318.318,0,0,1-.6.1L2.8,5.282a.318.318,0,0,0-.335-.166L.373,5.473a.318.318,0,0,1-.281-.536L1.576,3.419a.318.318,0,0,0,.054-.37L.645,1.168A.318.318,0,0,1,1.067.736l1.9.942a.318.318,0,0,0,.368-.062L4.823.1A.318.318,0,0,1,5.365.365Z",
  transform: "translate(39.105 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1736",
  "data-name": "Path 1736",
  d: "M4.323,2.161A2.161,2.161,0,1,1,2.162,0,2.161,2.161,0,0,1,4.323,2.161Z",
  transform: "translate(0 10.572)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1731",
  "data-name": "Path 1731",
  d: "M2.421,1.211A1.21,1.21,0,1,1,1.211,0,1.21,1.21,0,0,1,2.421,1.211Z",
  transform: "translate(68.398 6.748)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1732",
  "data-name": "Path 1732",
  d: "M3.458,1.729A1.729,1.729,0,1,1,1.729,0,1.729,1.729,0,0,1,3.458,1.729Z",
  transform: "translate(23.306 44.321)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_198",
  "data-name": "Ellipse 198",
  cx: 1.643,
  cy: 1.643,
  rx: 1.643,
  ry: 1.643,
  transform: "translate(16.196 11.194)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1733",
  "data-name": "Path 1733",
  d: "M2.594,1.3A1.3,1.3,0,1,1,1.3,0,1.3,1.3,0,0,1,2.594,1.3Z",
  transform: "translate(44.531 28.954)",
  fill: "#fff"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2226",
  "data-name": "Group 2226",
  transform: "translate(141.864 554.354) rotate(157)",
  opacity: 0.66
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_7842-2",
  "data-name": "Path 7842",
  d: "M5.365.365l-.308,2.1A.318.318,0,0,0,5.23,2.8l1.9.942a.318.318,0,0,1-.088.6l-2.093.356a.318.318,0,0,0-.261.267l-.308,2.1a.318.318,0,0,1-.6.1L2.8,5.282a.318.318,0,0,0-.335-.166L.373,5.473a.318.318,0,0,1-.281-.536L1.576,3.419a.318.318,0,0,0,.054-.37L.645,1.168A.318.318,0,0,1,1.067.736l1.9.942a.318.318,0,0,0,.368-.062L4.823.1A.318.318,0,0,1,5.365.365Z",
  transform: "translate(39.105 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1736-2",
  "data-name": "Path 1736",
  d: "M4.323,2.161A2.161,2.161,0,1,1,2.162,0,2.161,2.161,0,0,1,4.323,2.161Z",
  transform: "translate(0 10.572)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1731-2",
  "data-name": "Path 1731",
  d: "M2.421,1.211A1.21,1.21,0,1,1,1.211,0,1.21,1.21,0,0,1,2.421,1.211Z",
  transform: "translate(68.398 6.748)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1732-2",
  "data-name": "Path 1732",
  d: "M3.458,1.729A1.729,1.729,0,1,1,1.729,0,1.729,1.729,0,0,1,3.458,1.729Z",
  transform: "translate(23.306 44.321)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_198-2",
  "data-name": "Ellipse 198",
  cx: 1.643,
  cy: 1.643,
  rx: 1.643,
  ry: 1.643,
  transform: "translate(16.196 11.194)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1733-2",
  "data-name": "Path 1733",
  d: "M2.594,1.3A1.3,1.3,0,1,1,1.3,0,1.3,1.3,0,0,1,2.594,1.3Z",
  transform: "translate(44.531 28.954)",
  fill: "#fff"
}));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2219",
  "data-name": "Group 2219",
  transform: "matrix(0.995, -0.105, 0.105, 0.995, -15.566, 629.949)",
  opacity: 0.58
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9131",
  "data-name": "Path 9131",
  d: "M6.522,43.651,21.1,37.38,0,0Z",
  transform: "translate(20.329 0)",
  fill: "url(#linear-gradient-4)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9132",
  "data-name": "Path 9132",
  d: "M20.329,0,0,41.335l26.851,2.316Z",
  transform: "translate(0 0)",
  fill: "#6b99eb"
}));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2220",
  "data-name": "Group 2220",
  transform: "translate(25.209 699.216) rotate(-19)",
  opacity: 0.74
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1962",
  "data-name": "Group 1962",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9235",
  "data-name": "Path 9235",
  d: "M4.479.761a2.513,2.513,0,0,1,.761,1.863,2.506,2.506,0,0,1-.761,1.86,2.522,2.522,0,0,1-1.86.761A2.521,2.521,0,0,1,.761,4.484,2.535,2.535,0,0,1,0,2.624,2.542,2.542,0,0,1,.761.761,2.535,2.535,0,0,1,2.62,0,2.536,2.536,0,0,1,4.479.761Z",
  transform: "translate(6.21 0)",
  fill: "#7082ee"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9236",
  "data-name": "Path 9236",
  d: "M4.488.761a2.539,2.539,0,0,1,.761,1.86,2.547,2.547,0,0,1-.761,1.863,2.532,2.532,0,0,1-1.86.758A2.552,2.552,0,0,1,.761,4.484,2.547,2.547,0,0,1,0,2.621,2.54,2.54,0,0,1,.761.761,2.541,2.541,0,0,1,2.628,0,2.521,2.521,0,0,1,4.488.761Z",
  transform: "translate(6.678 17.174)",
  fill: "#7082ee"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9237",
  "data-name": "Path 9237",
  d: "M2.115,4.691A2.222,2.222,0,0,1,.531,3.836,2.261,2.261,0,0,1,.016,2.1,2.285,2.285,0,0,1,.889.517,2.216,2.216,0,0,1,2.622.02C4.028.163,11.9.208,15.367.153a2.262,2.262,0,0,1,1.679.653,2.195,2.195,0,0,1,.722,1.641,2.335,2.335,0,0,1-.671,1.68,2.136,2.136,0,0,1-1.644.7C11.791,4.908,3.72,4.859,2.115,4.691Z",
  transform: "translate(0 8.486)",
  fill: "#7082ee"
})));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2222",
  "data-name": "Group 2222",
  transform: "translate(-3.547 691.083) rotate(-7)",
  opacity: 0.21
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_7607",
  "data-name": "Path 7607",
  d: "M16.6,7.92s-8.938-3.644-9.1-5.133.1-4.682,8.088-1.266,11,3.879,9.955,7.246S17.987,13.5,17.987,13.5s4.208,3.986,1.235,8.834-8.786,6.431-14.341,3.7C-1.136,23.08-1.1,15.389,2.345,15.006s4.325,6,7.448,6.027,5.031-3.215,2.978-4.409S4.74,13.743,8.195,12,16.6,7.92,16.6,7.92Z",
  transform: "translate(0 0)",
  fill: "#5369c5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7608",
  "data-name": "Path 7608",
  d: "M1.513.157A5.459,5.459,0,0,1,3.341,4.794C2.9,8.286,1.094,9.674.173,9.948S2.3,8.593,2.636,4.827C2.887,2.044,1.587.913,1.344.67.659-.012.9-.154,1.513.157Z",
  transform: "translate(16.021 14.26)",
  fill: "#5369c5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7609",
  "data-name": "Path 7609",
  d: "M.19,0S5.025,1.354,5.937,2.963s-.615,3.6-2.571,4.45.211-.667,1.22-1.58,1.557-2.361.205-3.318C4.267,2.143-1.061.171.19,0Z",
  transform: "translate(19.091 3.737)",
  fill: "#5369c5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7610",
  "data-name": "Path 7610",
  d: "M.583.077s1.042.317.773.664S-.988-.34.583.077Z",
  transform: "translate(17.25 2.833)",
  fill: "#5369c5"
}));

var _ref20 = /*#__PURE__*/React.createElement("path", {
  id: "Path_10544",
  "data-name": "Path 10544",
  d: "M10.006.062S.631.937.655,3.87,6.884,8,7.741,7.552-.677,31,.04,32.128,6.5,35.87,7.345,34.8,18.7,3.31,17.952,2.563,13.124-.4,10.006.062Z",
  transform: "matrix(0.914, -0.407, 0.407, 0.914, 364.688, 690.982)",
  fill: "#6666f3",
  opacity: 0.39
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  id: "Path_10545",
  "data-name": "Path 10545",
  d: "M12.213.831l-.7,4.783a.724.724,0,0,0,.4.753l4.332,2.145a.724.724,0,0,1-.2,1.362l-4.766.811a.723.723,0,0,0-.595.608l-.7,4.783a.724.724,0,0,1-1.357.231L6.376,12.026a.724.724,0,0,0-.762-.377L.848,12.46a.724.724,0,0,1-.639-1.219L3.588,7.783a.724.724,0,0,0,.123-.842L1.468,2.66a.723.723,0,0,1,.962-.984L6.762,3.82A.723.723,0,0,0,7.6,3.678L10.98.22A.724.724,0,0,1,12.213.831Z",
  transform: "translate(382.58 601.013) rotate(128)",
  fill: "#fff",
  opacity: 0.61
});

var SvgMascotMobile = function SvgMascotMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 302,
    viewBox: "0 0 375 302",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_16",
    "data-name": "Mask Group 16",
    transform: "translate(0 -510)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3754",
    "data-name": "Group 3754"
  }, _ref3, _ref4, _ref5, _ref6, _ref7, /*#__PURE__*/React.createElement("g", {
    id: "Group_2223",
    "data-name": "Group 2223",
    transform: "translate(29.705 574.407)",
    opacity: 0.58,
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }, _ref8), _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMascotMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mascot-mobile.85990575.svg";
export { ForwardRef as ReactComponent };